import { jsxs, jsx } from "react/jsx-runtime";
const IconKeyboardDoubleArrowUpSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z" }),
      /* @__PURE__ */ jsx("path", { d: "m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z" })
    ]
  }
);
export {
  IconKeyboardDoubleArrowUpSvg
};
